import { AttInfo, AttInfoLocalBuffer, AttInfoLocalDisk } from '../mime-atts/types';

export function isLocalBufAtt(att: AttInfo): att is AttInfoLocalBuffer {
	return att.attType === 'local-buffer';
}

export function isLocalDiskAtt(att: AttInfo): att is AttInfoLocalDisk {
	return att.attType === 'local-disk';
}

export function attsToStr(atts: AttInfo[]): string {
	const attDescs = atts.map(o => {
		const descs: string[] = [];
		if (o.contentLocation) {
			descs.push('loc: ' + o.contentLocation);
		}
		if (o.contentId) {
			descs.push('id: ' + o.contentId);
		}
		if (o.contentType) {
			descs.push('type: ' + o.contentType);
		}

		return descs.join(', ');
	});

	return attDescs.join('; ');
}
